module.exports = __webpack_public_path__ + "static/media/plane-departure.63a64452.svg";